// extracted by mini-css-extract-plugin
export default {"container":"MaintenancePage_container__LJqM0","header":"MaintenancePage_header__lVKSI","icon":"MaintenancePage_icon__n7407","message":"MaintenancePage_message__8A3EQ"};